import React from 'react';

import CartCountBadge from '../../components/cart/CartCountBadge';

const TAB_BAR_ICON_SIZE = 64;
export const tabBarIcon =
  (FocusedIcon: any, UnfocusedIcon: any, badge = false) =>
  ({color, focused}: {focused: boolean; color: string; size: number}) => {
    const IconComponent = focused ? FocusedIcon : UnfocusedIcon;
    return (
      <>
        <IconComponent
          width={TAB_BAR_ICON_SIZE}
          height={TAB_BAR_ICON_SIZE}
          fill={color}
          color={color}
        />
        {!!badge && <CartCountBadge />}
      </>
    );
  };
